<div class="desempenho-ano-mobile">
  <!-- Loading State -->
  <div class="loading-state bg-white dark:bg-gray-800" *ngIf="isLoading">
    <div class="loading-spinner">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Carregando...</span>
      </div>
    </div>
    <h4 class="loading-title text-gray-800 dark:text-gray-100">Carregando dados de avaliação...</h4>
    <p class="loading-text text-gray-600 dark:text-gray-300">Aguarde enquanto buscamos as informações dos alunos e períodos avaliativos.</p>
  </div>

  <app-empty-state
    *ngIf="semCalendario && !isLoading"
    imagem="assets/images/professor-nao-possui-turmas.png"
    titulo="Esta turma não possui calendário escolar definido"
    descricao="Procure o(a) secretário(a) do seu estabelecimento de ensino para preencher estas informações no Cadastro de Turmas.">
  </app-empty-state>

  <app-empty-state
    *ngIf="!semCalendario && semPeriodoAvaliativo && !isLoading"
    imagem="assets/images/professor-nao-possui-turmas.png"
    titulo="Este componente curricular não possui as datas inicial e final definidas para o período avaliativo"
    descricao="Procure o(a) secretário(a) do seu estabelecimento de ensino para preencher estas informações no Cadastro de Turmas.">
  </app-empty-state>

  <div *ngIf="!semCalendario && !semPeriodoAvaliativo && semDesempenhos && !isLoading" class="border border-gray-200 dark:border-gray-700 rounded-lg bg-white dark:bg-gray-800 shadow-sm mt-4">
    <app-empty-state
      icone="notebook-pen"
      tema="yellow">
      <div class="text-sm text-slate-600 dark:text-slate-400 max-w-sm mx-auto flex flex-col gap-4">
        <p>Ainda não há desempenhos escolares por aqui.</p>
        <p>Não há registros de avaliação para este componente curricular.</p>
      </div>
    </app-empty-state>
  </div>

  <div *ngIf="!isLoading && !semCalendario && !semPeriodoAvaliativo && !semDesempenhos && (!linhas || linhas.length === 0)" class="border border-gray-200 dark:border-gray-700 rounded-lg bg-white dark:bg-gray-800 shadow-sm mt-4">
    <app-empty-state
      icone="users"
      titulo="Nenhum aluno encontrado"
      descricao="Não há alunos matriculados para este período avaliativo."
      tema="slate">
    </app-empty-state>
  </div>

  <div *ngIf="!isLoading && !semDesempenhos && linhas && linhas.length > 0 && (!colunas || colunas.length === 0)" class="border border-gray-200 dark:border-gray-700 rounded-lg bg-white dark:bg-gray-800 shadow-sm mt-4">
    <app-empty-state
      icone="calendar-x"
      titulo="Nenhum período avaliativo encontrado"
      descricao="Não há períodos avaliativos cadastrados para este ano letivo."
      tema="slate">
    </app-empty-state>
  </div>

  <!-- Lista de alunos em cards - Layout intuitivo -->
  <div class="alunos-cards-container" *ngIf="!isLoading && !semDesempenhos && linhas && linhas.length > 0 && colunas && colunas.length > 0">
    <div class="aluno-card bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700" *ngFor="let linha of linhas; trackBy: trackByEnturmacao">
      <div class="aluno-card-header">
        <div class="aluno-info">
          <div class="aluno-numero-badge bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200">{{ linha.enturmacao.numeroChamada }}</div>
          <div class="flex flex-col min-w-0 items-start gap-1">
            <div class="aluno-nome text-gray-900 dark:text-gray-100">{{ linha.enturmacao.matricula.nomeSocial || linha.enturmacao.matricula.nome }}</div>
            <app-label-situacao-matricula
              *ngIf="getSituacaoMatriculaBadge(linha)"
              [situacao]="getSituacaoMatriculaBadge(linha)">
            </app-label-situacao-matricula>
          </div>
        </div>
      </div>

      <div class="avaliacoes-section" *ngIf="colunas && colunas.length > 0">
        <div class="avaliacoes-grid grid grid-cols-3 gap-2 w-full items-start">
          <div class="avaliacao-item min-w-0 flex flex-col" *ngFor="let coluna of colunas; let colIndex = index; trackBy: trackByColuna">
            <div class="avaliacao-label">
              <span class="avaliacao-nome text-gray-800 dark:text-gray-100 line-clamp-2 leading-tight min-h-[2.5rem] flex items-end pb-1">{{ coluna.descricao || (coluna.rawValue?.periodoAvaliativo?.descricao || coluna.rawValue?.descricao) || 'Período' }}</span>
            </div>
            <div class="avaliacao-input-wrapper mt-0">
              <ng-container *ngIf="linha.notas && linha.notas[colIndex]; else notaVazia">
                <app-input-nota
                  [nota]="linha.notas[colIndex]"
                  [coluna]="coluna"
                  [configuracaoAvaliacao]="configuracaoAvaliacao"
                  [disabled]="!hasPermissionsToEdit"
                  [mostrarParecer]="showParecerMethod() && !!linha.notas[colIndex].$$permiteParecerAnual"
                  [mostrarCha]="hasAnyConfiguracaoCha"
                  (notaSalva)="onSalvar($event)"
                  (openParecer)="onShowParecer($event)"
                  (openCha)="onShowCHA($event)"
                  (openAvaliacaoDescritiva)="onShowAvaliacaoDescritiva($event)">
                </app-input-nota>
              </ng-container>
              <ng-template #notaVazia>
                <app-input-nota
                  [disabled]="!hasPermissionsToEdit"
                  [configuracaoAvaliacao]="configuracaoAvaliacao">
                </app-input-nota>
              </ng-template>

                <div *ngIf="linha.notas && linha.notas[colIndex]?.$$mensagemValidacao" class="w-full animate-fade-in mt-1.5 pr-2">
                    <div class="px-2.5 py-2 bg-red-50 border border-red-100 text-red-600 rounded text-[13px] text-left font-medium dark:bg-red-900/20 dark:border-red-800 dark:text-red-400 shadow-sm leading-snug">
                        {{ linha.notas[colIndex].$$mensagemValidacao }}
                    </div>
                </div>
            </div>
          </div>

          <div class="avaliacao-item min-w-0 flex flex-col" *ngIf="!ocultarDetalhes && linha.notaMediaFinal">
            <div class="avaliacao-label">
              <span class="avaliacao-nome text-gray-400 dark:text-gray-500 line-clamp-2 leading-tight min-h-[2.5rem] flex items-end pb-1">Média final</span>
            </div>
            <div class="avaliacao-input-wrapper mt-0">
              <app-input-nota
                [nota]="linha.notaMediaFinal"
                [configuracaoAvaliacao]="configuracaoAvaliacao"
                [disabled]="!hasPermissionsToEdit"
                [usarEditavelAnual]="true"
                [mostrarParecer]="showParecerMethod() && !!linha.notaMediaFinal.$$permiteParecerAnual"
                [mostrarCha]="hasAnyConfiguracaoCha"
                (notaSalva)="onSalvar($event)"
                (openParecer)="onShowParecer($event)"
                (openCha)="onShowCHA($event)"
                (openAvaliacaoDescritiva)="onShowAvaliacaoDescritiva($event)">
              </app-input-nota>
              <div *ngIf="linha.notaMediaFinal?.$$mensagemValidacao" class="w-full animate-fade-in mt-1.5 pr-2">
                <div class="px-2.5 py-2 bg-red-50 border border-red-100 text-red-600 rounded text-[13px] text-left font-medium dark:bg-red-900/20 dark:border-red-800 dark:text-red-400 shadow-sm leading-snug">
                        {{ linha.notaMediaFinal.$$mensagemValidacao }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
